module.exports = __webpack_public_path__ + "img/23_44.597bd17d.png";